<script setup lang="ts">
import DatePicker from "./DatePicker.vue";
import {onMounted, ref, useTemplateRef, watch} from "vue";
import {YearMonth} from "./marktberichte/Types.ts";
import {DatePickerMonths as months} from "./marktberichte/Globals.ts";

import {filterBerichte, updateCategories, getNewestAndOldest, showLogin} from "../modules/marktberichte.ts";

const props = defineProps<{
  generateFilters: boolean
}>();

const from = ref(new Date());
const to = ref(new Date());

const fromRef = useTemplateRef<InstanceType<typeof DatePicker>>('fromref');
const toRef = useTemplateRef<InstanceType<typeof DatePicker>>('toref');
const min = ref<YearMonth | undefined>(undefined);
const max = ref<YearMonth | undefined>(undefined);
let init = true;

declare let showAllinCMS: boolean;
declare let isLoggedIn: boolean;

const categories = ref<string[]>([]);
const catSet = new Set(
    Array.from(document.querySelectorAll('.marktberichte .marktberichte__bericht'))
        .map(node => node.getAttribute('data-cat') || '')
);
categories.value = [...catSet.values()];

function setFrom(yearmonth:YearMonth){
  from.value = parseGermanDate(yearmonth);
  min.value = yearmonth;
}

function setTo(yearmonth:YearMonth){
  to.value = parseGermanDate(yearmonth);
  max.value = yearmonth;
}

function parseGermanDate(yearmonth:YearMonth) {
  const month = yearmonth.month;
  const year = yearmonth.year

  if (month === undefined || isNaN(year)) {
    throw new Error('Invalid date format');
  }

  return new Date(year, month, 1);
}

function parentSetNow(){
  if (!init && showLogin()) return
  fromRef.value?.setPickerDateNow();
  toRef.value?.setPickerDateNow();
}

function parentSetFull(){
  if (showLogin()) return
  toRef.value?.setPickerDateNow();
  let dates_berichte = getNewestAndOldest()
  let oldest = dates_berichte[1]
  if (!oldest) return
  let oldestDate = new Date(oldest)
  fromRef.value?.setPickerDate({month:oldestDate.getMonth(),year:oldestDate.getFullYear()});
}

function dateChangeFeedback(){
  const hint = document.querySelector(".marktberichte__hint");
  if (!hint || init) return
  hint.classList.add('visible');
  setTimeout(() => {
    hint.classList.remove('visible');
  }, 2000);
}

watch(
    [min, max],
    ([newMin, newMax]) => {
      /*if(typeof newMin !== 'undefined' && typeof newMax !== 'undefined'){

        filterBerichte({
          type: 'date',
          min: `${months[newMin.month]} ${newMin.year}`,
          max: `${months[newMax.month]} ${newMax.year}`
        });
        updateCategories();
      }*/
      filterBerichte({
        type: 'date',
        min: typeof newMin !== 'undefined' ? `${months[newMin.month]} ${newMin.year}` : 'null',
        max: typeof newMax !== 'undefined' ? `${months[newMax.month]} ${newMax.year}` : 'null'
      });
      dateChangeFeedback();
      updateCategories();
      init = false;
    },
    { deep: true }
);

onMounted(() => {
  if (typeof isLoggedIn === 'undefined' || !isLoggedIn) {
    toRef.value?.setPickerDateNow();
    return
  }
  if (typeof showAllinCMS === 'undefined' || !showAllinCMS) {
    parentSetNow();
    let dates_berichte = getNewestAndOldest()
    let newest = dates_berichte[0]
    if (!newest) return
    let newestDate = new Date(newest)
    if (newestDate != to.value) {
      fromRef.value?.setPickerDate({month: newestDate.getMonth(), year: newestDate.getFullYear()});
    }
  }

})
</script>

<template>
  <div class="marktberichte__filters">
    <div class="marktberichte__date">
      <div class="marktberichte__date__label">Von:</div>
      <date-picker :on-date-update="setFrom" :no-future="true" :max="max" ref="fromref"/>
    </div>
    <div class="marktberichte__date">
      <div class="marktberichte__date__label">Bis:</div>
      <date-picker :on-date-update="setTo" :no-future="true" :min="min" ref="toref"/>
    </div>
    <div>
      <div class="marktberichte__filters__curr" @click="parentSetNow()">Aktueller Monat</div>
      <div class="marktberichte__filters__curr" @click="parentSetFull()">Alle anzeigen</div>
    </div>
  </div>
  <div id="hint" class="marktberichte__hint">Zeitspanne geändert</div>
  <div v-if="props.generateFilters" id="marktberichte__categories" class="marktberichte__categories">
    <div id="catFilter-all" class="d2buttonround d2buttonround--check d2buttonround--check--active">Alle</div>
    <template v-for="(cat, i) in categories">
      <input type="checkbox" :id="'catFilter-' + i" :data-cat="cat">
      <label :for="'catFilter-' + i" class="d2buttonround d2buttonround--check">{{ cat }}</label>
    </template>
    <div class="marktberichte__categoriestoggle" id="marktberichte__categoriestoggle"><span class="marktberichte__categoriestoggle__default">mehr anzeigen</span><span class="marktberichte__categoriestoggle__all">weniger anzeigen</span></div>
  </div>
</template>

<style scoped>

</style>